import { envConfig } from '@root/env';
import { EnumLocalStore } from '@/constant/enums';
import { message } from '@/utils/message';
import { localStg } from '@/utils/storage/local';

function createWebSocket() {

    const eventListenerMap = new Map;
    let webSocket = undefined;

    function registerEventListener(method, eventType, requestId) {
        let eventMap = eventListenerMap.get(eventType);
        if (!eventMap) {
            eventMap = new Map;
        }
        if (!requestId) {
            requestId = 'default';
        }
        console.log(`正在注册监听器 ${eventType}, requestId: ${requestId}`);
        console.log(method);
        eventMap.set(requestId, method);
        eventListenerMap.set(eventType, eventMap);
    }

    function send(data, eventType, requestId) {
        if (!eventType) {
            throw new Error('eventType不能为空!');
        }

        if (!webSocket || webSocket.readyState !== webSocket.OPEN) {
            message.error('连接已断开, 请重新刷新网页');
            console.log(eventType);
            return;
        }

        let param = { event: eventType, body: data, requestId: requestId };
        // console.log(`正在向${uri} 发送请求, 数据为${JSON.stringify(param)}`);
        webSocket.send(JSON.stringify(param));
    }

    function execute(eventType, data, event) {
        let requestId = data.requestId;
        if (!requestId) {
            requestId = 'default';
        }
        let eventMap = eventListenerMap.get(eventType);
        if (eventMap) {
            let method = eventMap.get(requestId);
            if (method) {
                method(data, event);
            }
        }
    }

    function open(projectName) {
        return new Promise((resolve, reject) => {
            if (!projectName) {
                throw new Error('Project name is required');
            }

            // let token = "eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJiNWM4MTExNzc5MDk0YzgzOTIxNjZiMTQ4ZThjMzFiZCIsImFjY291bnQiOiJ4aWFvZGkiLCJyb2xlTGlzdCI6W10sInVzZXJJZCI6ImI1YzgxMTE3NzkwOTRjODM5MjE2NmIxNDhlOGMzMWJkIiwicGxhdGZvcm1JZCI6IjAyM2ZhNGJiNjhiZDRkYWJiYzMwYThiMDBhMzhhOTc2Iiwic3ViIjoidXNlciIsImV4cCI6MTc1NzczMDMwNCwidXNlclRhZyI6MiwicGxhdGZvcm0iOiJjb3R0b24ifQ.U738m9qn5vkGxZA-tlOBP-k3xqr9NQQLdRrP1lwuU6g"
            let token = localStg.get(EnumLocalStore.jwtTokenName);
            webSocket = new WebSocket(`${envConfig.imServer}?${EnumLocalStore.authorizationHeaderName}=${token}&projectName=${projectName}`);
            webSocket.addEventListener('open', (event) => {
                console.log(`已成功连接到Im服务器 连接地址`);
                console.log(webSocket.url);
                execute('CUSTOM_OPEN', {}, event);
                resolve(event);
            });

            webSocket.addEventListener('close', (event) => {
                handleConnectionClosed(event);
                reject(event);
            });

            webSocket.addEventListener('error', (event) => {
                handleConnectionClosed(event);
                reject(event);
            });

            webSocket.addEventListener('message', (event) => {
                let data = event.data;
                if (!data) {
                    console.error(`收到的数据为空 \n ${event}`);
                    return;
                }

                let parsedData;
                try {
                    parsedData = JSON.parse(data);
                } catch (e) {
                    console.error(e);
                    console.error(`无法将数据${data} 反序列化为对象`);
                    return;
                }

                let eventType = parsedData['eventType'];
                let originalEventType = undefined;
                if ('ERROR' === eventType) {
                    originalEventType = parsedData['originalEventType'];
                    if (originalEventType) {
                        eventType = originalEventType;
                    }
                    if (parsedData.message) {
                        message.error(parsedData.message);
                    } else {
                        console.error(parsedData);
                    }
                }
                execute(eventType, parsedData, event);
            });
        })
    }

    function close() {
        console.log('执行webSocket.close()');
        if (webSocket) {
            webSocket.close();
        }
    }

    function handleConnectionClosed(event) {
        execute('CUSTOM_CLOSE', {}, event);
        message.error('连接已断开');
        console.log(event);
    }

    return { registerEventListener, send, close, open };
}

export const webSocketApi = createWebSocket;
